import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {hex2rgba, spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  filter: drop-shadow(0 ${spacing(-0.5, 2.5)} ${hex2rgba(cssTheme.default.day.everBlack.hex, 0.12)});
  transition: filter 0.2s ease-in-out;
  will-change: filter;
`

export const slotsGrid = css`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  width: 100%;
  align-items: center;
`

export const slotLeading = css`
  grid-column: 1;
  justify-self: start;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`

export const slotCenter = css`
  grid-column: 2;
  justify-self: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const slotTrailing = css`
  grid-column: 3;
  justify-self: end;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

export const disabledOpacityOverride = css`
  &:disabled {
    opacity: 1;
  }
`
